import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

const ProtectedRoute = ({ userType }) => {
  const { user, loading, activeRole, userRoles } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Check if user is authenticated
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user doesn't have any roles yet, redirect to selection page
  if (!userRoles || userRoles.length === 0) {
    return <Navigate to="/select-user-type" replace />;
  }

  // If userType is specified, check if user belongs to that group
  if (userType) {
    // Get original registration choice
    const originalUserType = user.attributes && user.attributes['custom:user_type'];
    
    // If trying to access a route that matches the original registration choice,
    // allow access regardless of active role
    if (originalUserType && userType === originalUserType) {
      return <Outlet />;
    }
    
    // For non-original routes, check if user has the role
    if (!userRoles.includes(userType)) {
      // If user doesn't have the role at all, redirect to their original dashboard
      if (originalUserType) {
        return <Navigate to={`/${originalUserType}`} replace />;
      } else if (activeRole) {
        return <Navigate to={`/${activeRole}`} replace />;
      }
    } else if (userType !== activeRole) {
      // If user has the role but it's not active, suggest switching
      return <Navigate to={`/switch-to/${userType}`} replace />;
    }
  }

  return <Outlet />;
};

export default ProtectedRoute;
